// @ts-ignore
import { removeToken, setToken } from '@/utils/auth'

/**
 * 判断ios or android
 */
export const system = (): string => {
  const u = navigator.userAgent

  let name
  if (
    u.indexOf('Android') > -1 ||
    u.indexOf('Adr') > -1 ||
    u.indexOf('hshhk/android') > -1
  ) {
    name = 'android'
  } else if (
    u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ||
    u.indexOf('hshhk/ios/') > -1
  ) {
    name = 'ios'
  } else {
    name = 'unknown'
  }

  return name
}

/**
 * 判断是否APP内部
 */
export const isApp = () => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端

  if (isAndroid) {
    return !!(window as any).HkAndroid
  }

  if (isiOS) {
    return !!(
      (window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.getBossInfoWithCallback
    )
  }
}
/**
 * 控制顶部导航栏的显示隐藏及透明度
 */
export const toggleTopbar = (alpha: number): void => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  const obj = JSON.stringify({ alpha })

  if (isAndroid) {
    // 调用原生的分享功能
    ;(window as any).HkAndroid && (window as any).HkAndroid.setNavibarAlpha(obj)
  }

  if (isiOS) {
    // 调用原生的分享功能
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.setNavibarAlpha &&
      (window as any).webkit.messageHandlers.setNavibarAlpha.postMessage(obj)
  }
}

/**
 * @description 获取用户信息
 * @param obj 传给原生的对象参数
 */
export const runGetUserInfo = (obj: Record<string, any>): void => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  const newObj = JSON.stringify(obj)

  if (isAndroid) {
    // 获取登录后的boss信息
    ;(window as any).HkAndroid &&
      (window as any).HkAndroid.getBossInfoWithCallback(newObj)
  }

  if (isiOS) {
    // 获取登录后的boss信息
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.getBossInfoWithCallback &&
      (
        window as any
      ).webkit.messageHandlers.getBossInfoWithCallback.postMessage(newObj)
  }
}

// 天气
export const getWeatherIcon = (obj: any): void => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  const newObj = JSON.stringify(obj)
  if (isAndroid) {
    // 获取登录后的boss信息
    ;(window as any).HkAndroid &&
      (window as any).HkAndroid.getWeatherIcon(newObj)
  }

  if (isiOS) {
    // 获取登录后的boss信息
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.getWeatherIcon &&
      (window as any).webkit.messageHandlers.getWeatherIcon.postMessage(newObj)
  }
}

/**
 * @description 获取url的query数据
 * @param variable 要获取的值
 */
export const getQueryVariable = (variable: string): boolean | string => {
  let query = ''
  if (window.location.search.substring(1)) {
    query = window.location.search.substring(1)
  } else {
    query =
      window.location.hash.split('?').length > 1
        ? window.location.hash.split('?')[1]
        : ''
  }
  const vars = query.split('&')
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return false
}

/**
 * @description 防抖
 * @param fn 执行的cb
 * @param wait 延迟时间
 */
export const debounce = (fn: (value: string) => void, wait: number): any => {
  let timer: any = null
  return function (params: any): void {
    if (timer !== null) {
      clearTimeout(timer)
    }
    const callNow = !timer
    timer = setTimeout(() => {
      timer = null
    }, wait)
    if (callNow) {
      fn(params)
    }
  }
}
/**
 * Native -> H5, 然后h5想要再客户端的返回按钮返回到Native
 */
export const cGoBack = () => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端

  if (isAndroid) {
    ;(window as any).HkAndroid && (window as any).HkAndroid.onNativeBackClick()
  }

  if (isiOS) {
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.onNativeBackClick &&
      (window as any).webkit.messageHandlers.onNativeBackClick.postMessage('aa')
  }
}
export const controlTopButton = (obj: unknown): void => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端

  const newObj = JSON.stringify(obj)

  if (isAndroid) {
    // 获取登录后的boss信息
    ;(window as any).HkAndroid &&
      (window as any).HkAndroid.setNavigationButtons(newObj)
  }

  if (isiOS) {
    // 获取登录后的boss信息
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.setNavigationButtons &&
      (window as any).webkit.messageHandlers.setNavigationButtons.postMessage(
        newObj
      )
  }
}

/**
 * h5控制客户端导航栏字体颜色
 * @param {*} color
 */
export const switchNavColor = (color: unknown): void => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  const newColor = JSON.stringify(color)

  if (isAndroid) {
    // 获取登录后的boss信息
    ;(window as any).HkAndroid &&
      (window as any).HkAndroid.setNavibarTintColor(newColor)
  }

  if (isiOS) {
    // 获取登录后的boss信息
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.setNavibarTintColor &&
      (window as any).webkit.messageHandlers.setNavibarTintColor.postMessage(
        newColor
      )
  }
}

/**
 * 埋点事件枚举
 */
export enum BuryingPoint {
  'Life_PointsShop_order' = 'Life_PointsShop_order',
  'mylink_points_FANS' = 'mylink_points_FANS',
  'Click_blindbox' = 'Click_blindbox',
  'Click_quote' = 'Click_quote',
  'Quote_record' = 'Quote_record',
  'key_BlindBox_earnhighpointscorner' = 'key_BlindBox_earnhighpointscorner',
  'key_BlindBox_finance' = 'key_BlindBox_finance',
  'key_BlindBox_insurance' = 'key_BlindBox_insurance',
  'key_BlindBox_securities' = 'key_BlindBox_securities',
  'key_BlindBox_remittance' = 'key_BlindBox_remittance',
  'key_BlindBox_shopping' = 'key_BlindBox_shopping',
  'Grab_evoucher' = 'Grab_evoucher',
  'Get_points' = 'Get_points',
  'Popup_mygarden' = 'Popup_mygarden',
  'H5_mygarden' = 'H5_mygarden',
  'JetsoVIP_subscribe' = 'JetsoVIP_subscribe',
  'JetsoVIP_coupon' = 'JetsoVIP_coupon',
  'Spend_points' = 'Spend_points',
  'Get_points_reminder' = 'Get_points_reminder'
}

/**
 * h5调用客户端 事件统计
 * @param obj
 */
export const logEventStatistics = (obj: {
  umkey: string
  param?: string
  value?: unknown
}): void => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端

  const newObj = JSON.stringify(obj)

  if (isAndroid) {
    // 获取登录后的boss信息
    ;(window as any).HkAndroid &&
      (window as any).HkAndroid.logEventStatistics(newObj)
  }

  if (isiOS) {
    // 获取登录后的boss信息
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.logEventStatistics &&
      (window as any).webkit.messageHandlers.logEventStatistics.postMessage(
        newObj
      )
  }
}
export const logEvent_new = (obj: {
  eventName: string
  params?: string
}): void => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端

  if (isAndroid) {
    ;(window as any).AnalyticsWebInterface &&
      (window as any).AnalyticsWebInterface.logEvent(
        obj.eventName,
        obj.params ? JSON.stringify(obj.params) : ''
      )
  }

  if (isiOS) {
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.logEvent &&
      (window as any).webkit.messageHandlers.logEvent.postMessage({
        eventName: obj.eventName,
        params: obj.params ? JSON.stringify(obj.params) : '{}'
      })
  }
}
/**
 * h5调用客户端开始/结束页面统计
 * @param obj pageId 页面id / start 1.开始；0.结束
 */
export const pageViewStatistics = (obj: {
  pageId: string
  start: number
}): void => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端

  const newObj = JSON.stringify(obj)

  if (isAndroid) {
    // 获取登录后的boss信息
    ;(window as any).HkAndroid &&
      (window as any).HkAndroid.pageViewStatistics(newObj)
  }

  if (isiOS) {
    // 获取登录后的boss信息
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.pageViewStatistics &&
      (window as any).webkit.messageHandlers.pageViewStatistics.postMessage(
        newObj
      )
  }
}

// xss正则
export function checkIsXSS(v: string): boolean {
  /* xss校验函数，返回值：true 表示存在xss漏洞，false：不存在 */
  if (typeof v === 'string' && v) {
    const exp = new RegExp(
      '\\b(document|onload|eval|script|img|svg|onerror|javascript|alert)\\b'
    )
    return exp.test(v)
  }
  return false
}
export const shareFun = (obj: any): void => {
  obj.img =
    obj.img ||
    `https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/shareLogo/shareLogo`
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端

  let fun = ''

  // 分享
  if (obj.type === 1) {
    if (isAndroid) {
      fun = 'initShare'
    }

    if (isiOS) {
      fun = 'setShareButton'
    }
  }

  // 紧急电话
  if (obj.type === 2) {
    fun = 'setEmergencyButton'
  }
  obj = JSON.stringify(obj)

  if (isAndroid) {
    // 调用原生的分享功能
    ;(window as any).HkAndroid && (window as any).HkAndroid[fun](obj)
  }

  if (isiOS) {
    // 调用原生的分享功能
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers[fun] &&
      (window as any).webkit.messageHandlers[fun].postMessage(obj)
  }
}
export const checkToken = (cb: (obj: any) => any, needLogin = false): void => {
  if (process.env.NODE_ENV === 'development') {
    const token = '818e407c-de6b-416d-8336-aa87fdf5c011'
    setToken(token)
    const userInfo = {
      user: {
        phone: '51644264',
        username: 'testww',
        msisdn: '92002009',
        email: 'mchaung@hk.chinamobile.com',
        userType: '1',
        vipLevel: '1',
        is_binded_account: 0,
        vipExpireDate: '2021-12-26 15:22:00'
      },
      authorization: token,
      boss: {
        access_token: token
      }
    }
    cb && cb(userInfo)
    // removeToken()
  }
  ;(window as any).getUserInfo = (obj: Record<string, any>) => {
    if (obj) {
      const token = `${obj.authorization}`
      setToken(token)
    } else {
      removeToken()
    }
    cb && cb(obj)
  }

  // 调用获取用户信息
  runGetUserInfo({ callbackName: 'getUserInfo', needLogin: needLogin })
}

/**
 * h5调用客户端 h5Cache
 *
 */
export const CacheInfo = (obj: any): void => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端

  const newObj = JSON.stringify(obj)

  if (isAndroid) {
    // 获取登录后的boss信息
    ;(window as any).HkAndroid && (window as any).HkAndroid.h5Cache(newObj)
  }

  if (isiOS) {
    // 获取登录后的boss信息
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.h5Cache &&
      (window as any).webkit.messageHandlers.h5Cache.postMessage(newObj)
  }
}

/*
图片预加载
 */
export const imgPreloader = (url: string) => {
  return new Promise<void>((resolve, reject) => {
    const image = new Image()
    image.src = url
    image.onload = () => {
      resolve()
    }
    image.onerror = () => {
      reject()
    }
  })
}
/*
图片预加载Promise.all
 */
export const imgsPreloader = (imgs: string[]) => {
  const promiseArr: any = []
  imgs.forEach(element => {
    promiseArr.push(imgPreloader(element))
  })
  return Promise.all(promiseArr)
}
/*
图片预加载Promise.all
 */
export const imgsPreloaders = (imgs: Array<any>) => {
  const promiseArr: any = []
  imgs.forEach((element: any) => {
    promiseArr.push(imgPreloader(element.buildImg))
  })
  return Promise.all(promiseArr)
}
/**
 * h5获取当前app版本
 * @param
 */
export const getAppMode = (obj: any) => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  obj = JSON.stringify(obj)
  if (isAndroid) {
    // 获取登录后的boss信息
    ;(window as any).HkAndroid && (window as any).HkAndroid.getAppMode(obj)
  }

  if (isiOS) {
    // 获取登录后的boss信息
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.getAppMode &&
      (window as any).webkit.messageHandlers.getAppMode.postMessage(obj)
  }
}

/**
 * h5获取当前app版本9.0 9.1
 * @param
 */
export const getVersionInfoWithCallback = (obj: any) => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  obj = JSON.stringify(obj)
  if (isAndroid) {
    // 获取登录后的boss信息
    ;(window as any).HkAndroid &&
      (window as any).HkAndroid.getVersionInfoWithCallback(obj)
  }

  if (isiOS) {
    // 获取登录后的boss信息
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.getVersionInfoWithCallback &&
      (
        window as any
      ).webkit.messageHandlers.getVersionInfoWithCallback.postMessage(obj)
  }
}

//判断版本号 新
export const isWhichVersion = (str: any) => {
  const arr = str.split('.')
  if (Number(arr[0]) > 9) {
    if (Number(arr[1]) >= 0) {
      return true
    }
  }
  if (Number(arr[0]) === 9) {
    if (Number(arr[1]) >= 1) {
      return true
    }
  }
  return false
}
//判断版本号
export const isWhichVersionNew = (): any => {
  const u = navigator.userAgent

  let name
  if (
    u.indexOf('Android') > -1 ||
    u.indexOf('Adr') > -1 ||
    u.indexOf('hshhk/android') > -1
  ) {
    name = 'android'
    const arr = u.split('/')[2].split('.')
    console.log(arr, '安卓')
    if (Number(arr[0]) > 9) {
      if (Number(arr[1]) >= 0) {
        return true
      }
    }
    if (Number(arr[0]) === 9) {
      if (Number(arr[1]) >= 1) {
        return true
      }
    }
    return false
  } else if (
    u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ||
    u.indexOf('hshhk/ios/') > -1
  ) {
    name = 'ios'
    const arr = u.split('/')
    const smallArr = Number(arr[2].replaceAll('.', ''))
    console.log(smallArr, 'smallArr', '苹果')
    if (smallArr >= 910) {
      return true
    }
    return false
  } else {
    name = 'unknown'
    return false
  }
}

//小冰——返回
export const closeWebview = (obj: any = '') => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  obj = JSON.stringify(obj)
  if (isAndroid) {
    // 获取登录后的boss信息
    ;(window as any).HkAndroid && (window as any).HkAndroid.closeWebview(obj)
  }

  if (isiOS) {
    // 获取登录后的boss信息
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.closeWebview &&
      (window as any).webkit.messageHandlers.closeWebview.postMessage(obj)
  }
}
// openinstall
export const OpenApp = (url: string, callback: any) => {
  const _url = url || ''
  const Value = `launchmylink://${_url}`
  const data = { launchmylink: Value }
  // let data = OpenInstall.parseUrlParams() // openinstall.js中提供的工具函数，解析url中的所有查询参数
  // @ts-ignore
  const OpenApp = new OpenInstall(
    {
      /* appKey必选参数，openinstall平台为每个应用分配的ID */
      appKey: 'umf9a4', //生产版本
      // appKey: 'xr2owd', //UAT版本
      /* 可选参数，自定义android平台的apk下载文件名；个别andriod浏览器下载时，中文文件名显示乱码，请慎用中文文件名 */
      // apkFileName : 'com.fm.openinstalldemo-v2.2.0.apk',
      /* 可选参数，是否优先考虑拉起app，以牺牲下载体验为代价 */
      // preferWakeup:true,
      /* 自定义遮罩的html */
      // mask:function(){
      //  return "<div id='openinstall_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
      // },
      /* openinstall初始化完成的回调函数，可选 */

      onready() {
        const m: any = this
        // let button = document.getElementById(id)
        // button.style.visibility = 'visible'
        /* 在app已安装的情况尝试拉起app */
        // m.schemeWakeup()
        if (typeof callback !== 'function') {
          /* 用户点击某个按钮时(假定按钮id为downloadButton)，安装app */
          m.wakeupOrInstall()
        } else {
          callback(m)
        }
        // button.onclick = function () {
        //   console.log('openappClick')
        //   m.wakeupOrInstall()
        //   return false
        // }
      }
    },
    data
  )
}
export const sharePic = (obj: any): void => {
  // obj.img =
  //   obj.img ||
  //   `https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/shareLogo/shareLogo`
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端

  const fun = 'sharePicTo'

  // 分享

  obj = JSON.stringify(obj)

  if (isAndroid) {
    // 调用原生的分享功能
    ;(window as any).HkAndroid && (window as any).HkAndroid[fun](obj)
  }

  if (isiOS) {
    // 调用原生的分享功能
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers[fun] &&
      (window as any).webkit.messageHandlers[fun].postMessage(obj)
  }
}

//客户端保存图片到相册
export const savePhoto = (obj: any) => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  obj = JSON.stringify(obj)
  if (isAndroid) {
    // 调用原生的分享功能
    ;(window as any).HkAndroid &&
      (window as any).HkAndroid.savePhotoToAlbum(obj)
  }

  if (isiOS) {
    // 调用原生的分享功能
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.savePhotoToAlbum &&
      (window as any).webkit.messageHandlers.savePhotoToAlbum.postMessage(obj)
  }
}
//获取系统是否静音
export const getVioceStatus = (obj: any) => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  obj = JSON.stringify(obj)
  if (isAndroid) {
    ;(window as any).HkAndroid &&
      (window as any).HkAndroid.getSilentModeStatus(obj)
  }

  if (isiOS) {
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.getSilentModeStatus &&
      (window as any).webkit.messageHandlers.getSilentModeStatus.postMessage(
        obj
      )
  }
}
// 获取app相关信息
export const getDeviceInfo = (obj: any) => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  const fn = (window as any)[obj.callbackName]
  obj = JSON.stringify(obj)
  if (isAndroid) {
    if (
      (window as any).HkAndroid &&
      (window as any).HkAndroid.getDeviceInfoWithCallback
    ) {
      ;(window as any).HkAndroid.getDeviceInfoWithCallback(obj)
    } else {
      fn({
        os: 'Android',
        device: null,
        appVersion: null
      })
    }
  }
  if (isiOS) {
    if (
      (window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.getDeviceInfoWithCallback
    ) {
      ;(
        window as any
      ).webkit.messageHandlers.getDeviceInfoWithCallback.postMessage(obj)
    } else {
      fn({
        os: 'iOS',
        device: null,
        appVersion: null
      })
    }
  }
}
//10.4版本 header新增右上角展示的方法
//10.4版本 header新增右上角展示的方法
export const showHeaderRight = (obj: string, flag?: boolean) => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  const uat = 'http://47.57.156.216'
  const pat = 'https://mylink.komect.com'
  if (flag) {
    if (isAndroid) {
      ;(window as any).HkAndroid && (window as any).HkAndroid.navRightIcons(obj)
    }
    if (isiOS) {
      ;(window as any).webkit &&
        (window as any).webkit.messageHandlers &&
        (window as any).webkit.messageHandlers.navRightIcons &&
        (window as any).webkit.messageHandlers.navRightIcons.postMessage(obj)
    }
  } else {
    if (isAndroid) {
      window.location.origin === 'http://47.57.156.216' ||
      window.location.origin === 'https://47.57.156.216'
        ? (window as any).HkAndroid &&
          (window as any).HkAndroid.navRightIcons(uat + obj)
        : (window as any).HkAndroid &&
          (window as any).HkAndroid.navRightIcons(pat + obj)
    }

    if (isiOS) {
      window.location.origin === 'http://47.57.156.216' ||
      window.location.origin === 'https://47.57.156.216'
        ? (window as any).webkit &&
          (window as any).webkit.messageHandlers &&
          (window as any).webkit.messageHandlers.navRightIcons &&
          (window as any).webkit.messageHandlers.navRightIcons.postMessage(
            uat + obj
          )
        : (window as any).webkit &&
          (window as any).webkit.messageHandlers &&
          (window as any).webkit.messageHandlers.navRightIcons &&
          (window as any).webkit.messageHandlers.navRightIcons.postMessage(
            pat + obj
          )
    }
  }
}

//用于区分版本的函数（兼容ios和安卓）2024/2 新增
//组件中调用的示例
// window.xxxMethod=(obj)=>{
//   console.log('aos',Number(obj.replace(/\./g,'')))
// }
// let x=getVersionForAosAndIos({callbackName:'xxxMethod'})
// if(x){
//   console.log('ios',x)
// }
export const getVersionForAosAndIos = (obj): undefined | number => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  if (isAndroid) {
    ;(window as any).HkAndroid &&
      (window as any).HkAndroid.getVersionInfoWithCallback(JSON.stringify(obj)) //obj = {callbackName:'xxx'} xxx为自定义window方法 xxx接受一个obj参数 对obj进行正则替换Number(obj.replace(/\./g,''))
  }
  if (isiOS) {
    const u = navigator.userAgent
    const arr = u.split('/')
    const version = Number(arr[2].replaceAll('.', ''))
    return version
  }
  //注释
  //version 一个数字 如：1020（对应10.2.0）
}

//接口获取到unitId后 调用客户端方法进行谷歌广告初始化
//每次打开广告前，都要重新加载一次广告。如果单页面内有多次打开广告的需求，建议在上一次广告结束后就立刻进行下一次广告的加载
export const mylinkInitGoogleAd = (obj: {
  callbackName: string
  unitId: string
  adType: number
}) => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  //obj = {callbackName:'xxx',unitId:'',adType:''} xxx为自定义window方法  unitId 广告单元id adType 0-激励广告  1-插入式广告
  const jsonObj = JSON.stringify(obj)
  if (isAndroid) {
    ;(window as any).HkAndroid &&
      (window as any).HkAndroid.mylinkInitGoogleAd(jsonObj)
  }
  if (isiOS) {
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.mylinkInitGoogleAd &&
      (window as any).webkit.messageHandlers.mylinkInitGoogleAd.postMessage(
        jsonObj
      )
  }
}

//调用客户端方法进行谷歌广告展示 需要在初始化完成之后
export const mylinkStartGoogleAd = (obj: { callbackName: string }) => {
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  //obj = {callbackName:'xxx'} xxx为自定义window方法
  const jsonObj = JSON.stringify(obj)
  if (isAndroid) {
    ;(window as any).HkAndroid &&
      (window as any).HkAndroid.mylinkStartGoogleAd(jsonObj)
  }
  if (isiOS) {
    ;(window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.mylinkStartGoogleAd &&
      (window as any).webkit.messageHandlers.mylinkStartGoogleAd.postMessage(
        jsonObj
      )
  }
}


//refreshHomeItems 刷新方法需要兼容旧客户端没有该方法
export const refreshHomeItems = (): void => { 
  const name = system()
  let obj = JSON.stringify({ "items": [302] })
  if (name === 'android') {
   if((window as any).HkAndroid && (window as any).HkAndroid.refreshHomeItems){
    (window as any).HkAndroid.refreshHomeItems(obj)
   }
  }
  if (name === 'ios') {
    if((window as any).webkit && (window as any).webkit.messageHandlers && (window as any).webkit.messageHandlers.refreshHomeItems && (window as any).webkit.messageHandlers.refreshHomeItems.postMessage) {
      (window as any).webkit.messageHandlers.refreshHomeItems.postMessage(obj)
    }
  }
}


//判断客户端是否存在该方法
export const checkExistsFuncName = (funcName:string) =>{
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  if (isiOS) {
    console.log(" checkExistsFuncName ios打印：",(window as any).webkit &&(window as any).webkit.messageHandlers &&(window as any).webkit.messageHandlers[funcName])
    return (window as any).webkit &&(window as any).webkit.messageHandlers &&(window as any).webkit.messageHandlers[funcName]
  } else if (isAndroid) {
    console.log('checkExistsFuncName android打印：',(window as any).HkAndroid && (window as any).HkAndroid[funcName])
    return (window as any).HkAndroid && ((window as any).HkAndroid[funcName] || (window as any).android[funcName])
  } else {
    console.log('判断进到false')
    return false;
  }
}

//调用客户端loading展示
export const mylinkStartLoading = (callback:Function) => { 
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  if (checkExistsFuncName("LoadingPage")) {
    if(isAndroid){
      // ;(window as any).HkAndroid.LoadingPage()
      if((window as any).HkAndroid.LoadingPage){
        ;(window as any).HkAndroid.LoadingPage()
      }else if((window as any).android.LoadingPage){
        ;(window as any).android.LoadingPage()
      }
    }
    if(isiOS){
      ;(window as any).webkit.messageHandlers.LoadingPage.postMessage("aa")
    }
  } else {
    // 兼容老版本loading
    callback()
  }
}

export const mylinkStopLoading = (callback:Function) => { 
  const name = system()
  const isAndroid = name === 'android' // android终端
  const isiOS = name === 'ios' // ios终端
  if (checkExistsFuncName("StopLoadingPage")) {
    if(isAndroid){
      // ;(window as any).HkAndroid.StopLoadingPage()
      ;(window as any).android.StopLoadingPage()
      if((window as any).HkAndroid.StopLoadingPage){
        ;(window as any).HkAndroid.StopLoadingPage()
      }else if((window as any).android.StopLoadingPage){
        ;(window as any).android.StopLoadingPage()
      }
    }
    if(isiOS){
      ;(window as any).webkit.messageHandlers.StopLoadingPage.postMessage("aa")
    }
  } else {
    // 兼容老版本loading
    callback()
  }
}